// Will be used to generate ld+json for the page of the scooter detail
export let scooterLdJson = (data: any) => {
    let creativeWork = {
        "@context": "https://schema.org",
        "@type": "TwoWheeler",
        "url": "https://www.scootland.cz/skutr-" + data?.scooter?.url,
        "brand": {
            "@type": "Brand",
            "name": data?.scooter?.producer
        },
        "model": data?.scooter?.name,
        "engineSpecification": {
            "@type": "PropertyValue",
            "name": "Motor",
            "value": data?.scooter?.engine + ", " + data?.scooter?.ccm + " ccm"
        },
        "image": data.scooter?.main_image.url_medium,
        "name": data?.scooter?.producer + " " + data?.scooter?.name + " " + data?.scooter?.ccm + " ccm, ",
        "description": "Široká nabídka náhradních dílů skladem. Rychlé dodání a díly přesně pasující na skútr "
            + data?.scooter?.producer + " " + data?.scooter?.name + " " + data?.scooter?.ccm + " ccm, "
            + (data?.scooter?.years !== undefined ? data.scooter?.years : '')
    };
    return Object.assign({}, scooterLdJson, creativeWork);
}
export let productLdJson = (data: any) => {
    const isVariant = data?.product?.variants?.length > 0;
    let offers: any;
    if (!isVariant) {
        offers = {
            "@type": "Offer",
            "priceCurrency": "CZK",
            "price": data?.product?.price,
            "seller": {
                "@type": "Organization",
                "name": "Scootland.cz"
            }
        }} else {
        offers = [];
        data?.product?.variants?.forEach((variant: any) => {
            offers.push({
                "@type": "Offer",
                "priceCurrency": "CZK",
                "price": variant.price,
                "seller": {
                    "@type": "Organization",
                    "name": "Scootland.cz"
                }
            });
        });
    }
            
            
    let creativeWork = {
        "@context": "https://schema.org",
        "@type": "Product",
        "url": "https://www.scootland.cz/zbozi/" + data?.product?.url,
        "name": data?.product?.name,
        "image": data.product?.main_image_new.url_medium,
        "description": data?.product?.description,
        "offers": offers
        };
    return Object.assign({}, scooterLdJson, creativeWork);
}

// scooterLdJson With additional properties
export let scooterLdJsonWithProps = (data: any, technical: any) => {
    let additionalProperties: any[] = [];
    // foreach on technical
    technical.forEach((item: any) => {
        additionalProperties.push({
            "@type": "PropertyValue",
            "name": item.name,
            "value": item.value
        });
    });
    
    let creativeWork = {
        "@context": "https://schema.org",
        "@type": "TwoWheeler",
        "url": "https://www.scootland.cz/skutr-" + data?.scooter?.url,
        "brand": {
            "@type": "Brand",
            "name": data?.scooter?.producer
        },
        "model": data?.scooter?.name,
        "engineSpecification": {
            "@type": "PropertyValue",
            "name": "Motor",
            "value": data?.scooter?.engine + ", " + data?.scooter?.ccm + " ccm"
        },
        "weight": data?.scooter?.weight,
        "image": data.scooter?.main_image.url_medium,
        "additionalProperty": additionalProperties,
        "name": data?.scooter?.producer + " " + data?.scooter?.name + " " + data?.scooter?.ccm + " ccm, ",
        "description": "Široká nabídka náhradních dílů skladem. Rychlé dodání a díly přesně pasující na skútr "
            + data?.scooter?.producer + " " + data?.scooter?.name + " " + data?.scooter?.ccm + " ccm, "
            + (data?.scooter?.years !== undefined ? data.scooter?.years : '')
    };
    return Object.assign({}, scooterLdJson, creativeWork);
}
/*
+ data?.scooter?.year_from + " " + data?.scooter?.year_till,

<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "TwoWheeler",
  "name": "Název skútru",
  "description": "Detailní popis skútru",
  "brand": {
    "@type": "Brand",
    "name": "Značka skútru"
  },
  "model": "Model skútru",
  "fuelType": "Typ paliva",
  "engineSpecification": {
    "@type": "PropertyValue",
    "name": "Motor",
    "value": "Typ motoru, objem válců"
  },
  "weight": "Hmotnost",
  "maximumSpeed": "Maximální rychlost",
  "color": "Barva",
  "numberOfWheels": 2,
  "url": "URL_na_stránku_s_detaily",
  "image": "URL_k_obrázku",
  "additionalProperty": [
    {
      "@type": "PropertyValue",
      "name": "Kapacita palivové nádrže",
      "value": "objem v litrech"
    },
    {
      "@type": "PropertyValue",
      "name": "Typ pneumatik",
      "value": "např. městské, terénní"
    },
    {
      "@type": "PropertyValue",
      "name": "Délka skútru",
      "value": "rozměr v cm"
    },
    {
      "@type": "PropertyValue",
      "name": "Šířka skútru",
      "value": "rozměr v cm"
    },
    {
      "@type": "PropertyValue",
      "name": "Výška skútru",
      "value": "rozměr v cm"
    }
  ]
}
</script>

 */